import AbstractFormPage from './AbstractFormPage';
import AbstractProcessingPage from './AbstractProcessingPage';
import DebugPage from './DebugPage';
import FormEditPage from './FormEditPage';
import FormIndexPage from './FormIndexPage';
import FormShowPage from './FormShowPage';
import ProfilePage from './ProfilePage';
import SubmissionIndexPage from './SubmissionIndexPage';
import SubmissionPage from './SubmissionPage';

export const pages = {
    AbstractFormPage,
    AbstractProcessingPage,
    DebugPage,
    FormEditPage,
    FormIndexPage,
    FormShowPage,
    ProfilePage,
    SubmissionIndexPage,
    SubmissionPage,
};
